import React, { FC } from 'react';
import { Entry, EntryFields } from 'contentful';
import { BLOCKS } from '@contentful/rich-text-types';

import { StyledCardList } from '../styled';

// eslint-disable-next-line import/no-cycle
import AccordionEntry from './components/AccordionEntry';

export type AccordionProps = {
  name: string;
  accordionEntries: AccordionEntryData[];
};

export type AccordionEntryData = Entry<{
  name: string;
  label: string;
  // Need to enforce type for body.nodeType
  // Otherwise, we get the below error
  // Type '"document"' is not assignable to type 'BLOCKS.DOCUMENT'. ts(2345)
  body: EntryFields.RichText & {
    nodeType: BLOCKS.DOCUMENT;
  };
}>;

type AccordionGroupDataProps = {
  accordionGroupData: Entry<AccordionProps>;
};

const Accordion: FC<AccordionGroupDataProps> = ({ accordionGroupData }) => (
  <StyledCardList>
    {accordionGroupData?.fields?.accordionEntries?.map((accordionEntryData) => (
      <AccordionEntry
        key={accordionEntryData?.sys?.id}
        accordionEntryData={accordionEntryData}
      />
    ))}
  </StyledCardList>
);

export default Accordion;
